import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

export interface LectureDTO {
  id: string;
  title: string;
  chapterId: string | null;
  createdAt: string;
  updatedAt: string;
  order: number;
}

interface LecturesResponse {
  data?: LectureDTO[];
  error?: ApiError;
}

export const getLectures = async (): Promise<LecturesResponse> => {
  try {
    const response = await axios.get("/lecture/all");
    return { data: response.data };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};